import { Box } from '@modusign/design-system';

export default function TemplateHeaderDivider() {
  return (
    <Box display="inline-block" height="22px" width="1px">
      <Box
        backgroundColor="navigationBackgroundSecondaryBase"
        display="inline-block"
        height="100%"
        width="100%"
      />
    </Box>
  );
}
